import React, { useState, useEffect } from 'react';
//import '../css/blog.css';
import { GetAllCategory } from '../services/apiservice';
import Loader from './Loader';

const CategoryWidget = () => {
  const [blogCategory, setBlogCategory] = useState([]);
  const [loading, setLoading] = useState(true);

  const fillBlogCategory = async () => {
    try {
      const categoryList = await GetAllCategory();
      const jsonCategoryList = JSON.parse(categoryList);
      setBlogCategory(jsonCategoryList);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching the category data:', error);
    }
  }

  useEffect(() => {
    fillBlogCategory();
  }, []);

  return (
    <>
      <h3 class="title">Categories</h3>
      <ul>
        {
          loading ? <Loader /> :
            blogCategory?.map((item) => (
              <li>
                <a href={"/category/" + item.paramlink}>
                  {item.title}
                </a>
              </li>
            ))
        }
      </ul>
    </>
  );
};

export default CategoryWidget;